import { ScheduleFeedItem } from '../scheduleFeedItem/scheduleFeedItem';
import styles from './styles.module.scss';

export const ScheduleFeedLoader = () => {
	const items = Array.from({ length: 50 }, (_, i) => i + 1);
	return (
		<div className={styles['schedule-feed-list']}>
			{items.map((index) => {
				return <ScheduleFeedItem key={index} isLoader={true} />;
			})}
		</div>
	);
};
